enum State {
  NOT_STARTED,
  STARTED,
  FINISHED,
  FAILED
}

export default State
